import { defineStore } from 'pinia';

export default defineStore('app', () => {
  const showLoading = ref<boolean>(false);
  const loadingMessage = ref<string | null>(null);
  const timeoutId = ref<ReturnType<typeof setTimeout> | null>(null);

  watch(showLoading, (newValue) => {
    if (!newValue) {
      // Clear any existing timeout before setting a new one
      if (timeoutId.value) {
        clearTimeout(timeoutId.value);
      }
      // Clear the loading message when loading is hidden
      timeoutId.value = setTimeout(() => {
        loadingMessage.value = null;
      }, 300);
    }
  });

  function toggleLoading(value: boolean, message?: string) {
    showLoading.value = value;
    if (showLoading.value) {
      loadingMessage.value = message || null;
    }
  }

  return {
    showLoading,
    loadingMessage,
    toggleLoading,
  };
});
